export default "__VITE_ASSET__BX2SlJj6__"